import { GetterTree } from 'vuex'
import { AddressBooksState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<AddressBooksState, RootState> = {
    addressBooks:state => state.addressBooks,
    addressBookContacts:state => state.addressBookContacts,
    addressBookItem:state => state.addressBookItem,
};
